"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPropertyItemPasswordHashText = void 0;
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../../models");
var ConfirmPropertyItem_1 = require("../ConfirmPropertyItem");
var PASSWORD_VALUE = 'セキュリティ保護のため、表示していません';
var ConfirmPropertyItemPasswordHashText = function (_a) {
    var className = _a.className, color = _a.color, propertyId = _a.propertyId;
    return (react_1.default.createElement(ConfirmPropertyItem_1.ConfirmPropertyItem, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.passwordHash, inputFormatType: models_1.PASSWORD_HASH_PROPERTY_INPUT_TYPE.text, className: className, color: color }, PASSWORD_VALUE));
};
exports.ConfirmPropertyItemPasswordHashText = ConfirmPropertyItemPasswordHashText;
